module.exports = __webpack_public_path__ + "img/parking-info-4@2x.0de87b2c.png";